import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Dashboard from "../views/Dashboard.vue";
import Checkin from "../views/Checkin.vue";
import Members from "../views/Members.vue";
import EntranceInfo from "../views/EntranceInfo.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresVisitor: true,
    },
  },
  {
    path: "/checkin",
    name: "Checkin",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Checkin,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/clockin",
    name: "Clockin",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Clockin.vue"),
  },
  {
    path: "/gymcount",
    name: "Gymcount",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Gymcount.vue"),
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/members",
    name: "Members",
    component: Members,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/memberhome",
    name: "MemberHome",
    component: () => import("../views/MemberHome.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/sales",
    name: "Sales",
    component: () => import("../views/Sales.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/products",
    name: "Products",
    component: () => import("../views/Products.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/privates",
    name: "Privates",
    component: () => import("../views/Privates.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/reports",
    name: "Reports",
    component: () => import("../views/Reports.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/classes",
    name: "GClasses",
    component: () => import("../views/Classes.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/qrcodes",
    name: "Qrcodes",
    component: () => import("../views/Qrcodes.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/misc",
    name: "Misc",
    component: () => import("../views/Misc.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/joinclass/:id",
    name: "JoinClass",
    component: () => import("../views/ClassesJoin.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/test",
    name: "Test",
    component: () => import("../views/Test.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/entranceinfo",
    name: "EntranceInfo",
    component: EntranceInfo,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
